import React, { useState, useEffect } from "react";
import { withOidcSecure } from "@axa-fr/react-oidc";
import { width } from "../../../CustomComponents/DynamicCard/DynamicCardStyles";
import { useTranslation } from "react-i18next";
import HomeLayout from "../../../Layout/HomeLayout";
import DynamicCard from "../../../CustomComponents/DynamicCard";
import { useNavigate } from "react-router";
import LineBreaks, {
  ClimbManageSettingsSidebar,
  retrieveData,
} from "../../../../utils";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../CustomComponents/Loader";
import {
  COMPLETE_SAVING_GOAL,
  COVERED_BY_KUDZU_PLUS,
  GET_ALL_SPEND_ALERTS,
  GET_CLIMB_FEATURES,
  SAVINGS_GOALS,
  SPENDING_ALERT,
  STATUS_SUCCESS_CODE,
} from "../../../../network/URLConstants";
import {
  GetApiHeadersWithBearer,
  GetRequest,
} from "../../../../network/NetworkUtils";
import { appTheme } from "../../../../helpers/utils/Utils";
import ProgressBar from "../../../CustomComponents/ProgressBar";
import moment from "moment";
import logFirebaseEvents from "../../../LogFirebaseEvents";
import Modal from "../../../CustomComponents/Modal"
import SuccessRemoveGoalConfirm from "../SuccessRemoveGoalConfirm";
import DoneModalGoalRemove from "../DoneModalGoalRemove";
import { addLineBreaks } from "../../../../utils";
import CompleteSavingGoalConfirmRemoval from "../CompleteSavingGoalConfirmRemoval";
import TransaferFundsCompleteGoalModal from "../TransaferFundsCompleteGoalModal";
import CompletedDoneModalGoalRemove from "../CompletedDoneModalGoalRemove";
import { SAVING_CARD_CODE } from "../../../../helpers/utils/Utils";
import { PostRequest } from "../../../../network/NetworkUtils";
import { REMOVESAVINGGOAL } from "../../../../network/URLConstants";
import SuccesRemoveGoal from "../SuccesRemoveGoal";
import TransferErrorModal from "../AddSavingGoal/TransferErrorModal";
import { CHECKING_CARD_CODE } from "../../../../helpers/utils/Utils";
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle';

const ManageSavingGoalDetail = () => {
  const kudzuPlusTrue = useSelector((state) => state.kudzuPlusTrue);
  const appThemeData = appTheme(kudzuPlusTrue)
    const { t } = useTranslation();
    useDocumentTitle(t('page_title_savings_goal_details'));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cards = useSelector((state) => JSON.parse(state.userCards));
  const [isLoading, setIsLoading] = useState(false);
  const [spendAlertsArray, setspendAlertsArray] = useState(null);
  const [showSubItems, setShowSubItems] = useState(false);
  const [isClimbings, setisClimbings] = useState([]);
  const [isOptIn, setIsOptIn] = useState("");
  const [SpendingAlertCode, setSpendingAlertCode] = useState("");
  const [SpendingCount, setSpendingCount] = useState(0);
  const climbFeatures = useSelector((state) => state.climbFeatures);
  const enabledClimbings = climbFeatures?.filter(
    (response) => response.enabled === true
  );
  const isCoveredByKudzuOptedIn = enabledClimbings?.some(
    (item) => item.code === "CoveredByKudzu" && item.optedIn
  );
  const accessToken = useSelector((state) => state.accessToken);
  const isPrimrayKey =
    cards !== null ? (cards !== null ? cards?.find((item) => (item.AccountTypeBit63 == CHECKING_CARD_CODE)).CardKey : 0) : 0;
  const [
    isCoveredByKudzuIneligibleSetupSavings,
    setIsCoveredByKudzuIneligibleSetupSavings,
  ] = useState(false);

  const [isCoveredByKudzuIneligible, setIsCoveredByKudzuIneligible] =
    useState(false);
  const savingsCardExist = cards?.some(
    (item) => item.AccountTypeName === "Savings"
  );
  const savingsWithBalanceOver50 = cards?.find(
    (obj) => obj.AccountTypeBit63 == 32 && obj.Balance >= 50
  );
  const isCoveredByKudzuPlusOptedIn = enabledClimbings?.some(
    (item) => item.code === COVERED_BY_KUDZU_PLUS && item.optedIn
  );

  const goalKeyData = useSelector(
    (state) => state.savingGoalResponseData.goalKey
  );

  const accountObj = useSelector((state) => state.accountTypes);
  const frequecyDataGetting = useSelector((state) => state.frequecyData);
  const issavingsGoalEligible = isClimbings?.find(item => item?.code === SAVINGS_GOALS);
  const isSavingsGoalsOptedIn = enabledClimbings?.some(item => item.code === SAVINGS_GOALS && item.optedIn)
  const hasSavingGoal = useSelector((state) => state.hasSVGGoal);
  const AddAccountType = useSelector((state) => state.savingGoalAccountTypeObj);
  const { AccountType, AccountName, AccountId, fromAccount } = AddAccountType;
  const hasMultipleSVGGoals = accountObj.filter(acc => acc.AccountType === "SVGGoal").length > 1;
 
  // remove goal 
  const [RemoveGoalerrorModalDouble, setRemoveErrorModalDouble] = useState(false);
  const [RemoveGoalErrorModalConfirm, setRemoveGoalErrorModalConfirm] = useState(false);
  const [removegoaldoneModal, setRemoveGoalDoneModalOpen] = useState(false);
  const [removeErrorMsg, setRemoveErrorMsg] = useState(false)

  const closeGoalRemoveDoubleCCheck = () => {
    setRemoveErrorModalDouble(false);
  };

  const handleTransfer = async () => {
    const deviceId = await retrieveData("updatedDeviceId");
    const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
    const savingsAccount = cards?.find(
      (account) => account.AccountTypeBit63 == SAVING_CARD_CODE
    );

    const url = REMOVESAVINGGOAL(savingsAccount.CardKey, manageSavingDataObj?.goalKey);
    const response = await PostRequest(url, null, headers);
    const responseJson = JSON.parse(response);
    if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
      setRemoveGoalDoneModalOpen(true);
      setRemoveGoalErrorModalConfirm(false);
    } else {
      var arrMessages = responseJson.Messages;
      var message = arrMessages[0];
      var displayText = message.DisplayText;
      setRemoveGoalErrorModalConfirm(false);
      setRemoveErrorMsg(true)
      setErrorMsg(displayText)
    }
  };

  const handleSavinggoalRemove = () => {
      dispatch({
      type: "SAVING_GOALS",
      payload: { key: "GoalKey", value: manageSavingDataObj?.goalKey },
    });
    openGoalRemoveDoubleCheck(true);
  };

  const openGoalRemoveDoubleCheck = (value) => {
    setRemoveErrorModalDouble(true);
  };
 
  const removeSavigGoalClick = () => {

    if (manageSavingDataObj?.FundMoved === 0) {
      dispatch({ type: 'ACCOUNT_BALANCE', payload: { accountBalance: null } });
      dispatch({ type: 'IS_INTERNAL_ACCOUNT', payload: { isInternalAccount: false } });
      setRemoveErrorModalDouble(false);
      setRemoveGoalErrorModalConfirm(true); 
    } else {
      handleTransfer()
    }

  };        

  const closeConfirmremoveGoaal = () => {
    setRemoveGoalErrorModalConfirm(false);
    navigate("/Toolkit/SavingGoals/ManageSavingGoal")
  };

  const handleDoneRemove = (transferBtn) => {
    if (transferBtn === "success") {
      setRemoveGoalDoneModalOpen(true);
      setRemoveGoalErrorModalConfirm(false);
    } else {
      setRemoveGoalErrorModalConfirm(false);
      setRemoveErrorMsg(true)
      setErrorMsg(transferBtn)
    }

  };

  const closeRomvegoalSuccessfullDone = () => {
    navigate('/Toolkit/SavingGoals/ManageSavingGoal')
    setRemoveGoalDoneModalOpen(false);
    setRemoveGoalErrorModalConfirm(false);
  };

  const navigateremovegoalDoubleConfirm = () => {
    dispatch({ type: "RESET_ALLOCATE_FUND" })
    dispatch({ type: "RESET_SAVING_GOALS" })
    navigate("/Toolkit/ToolkitMenu");
  };

  const handleTranferCloseModal = () => {
    setRemoveErrorMsg(false);
    setRemoveGoalErrorModalConfirm(false);
  }


  //Alllocate Saving Goal  
  const HeadingStyles =
    "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] font-normal text-[var(--oops-edit-clr)]";
  const SubHeadingStyles =
    "font-serif-pro modal-title lg:text-[33px] md:text-[33px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] font-normal text-[var(--modal-edit-spendsense)] md:w-[80%]";
  const [errorModalDouble, setErrorModalDouble] = useState(false);
  const [errorModalConfirm, setErrorModalConfirm] = useState(false);
  const [doneModal, setDoneModalOpen] = useState(false);
  const [trasferErrorMsg, setTransferErrorMsg] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')
  const closeRemoveDoubleCCheck = () => {
    setErrorModalDouble(false);
    navigate("/Toolkit/ToolkitMenu")
  };

  const removeGoalClick = () => {
    dispatch({ type: 'ACCOUNT_BALANCE', payload: { accountBalance: null } });
    dispatch({ type: 'IS_INTERNAL_ACCOUNT', payload: { isInternalAccount: false } });
    setErrorModalDouble(false);
    setErrorModalConfirm(true);
  };

  const openRemoveDoubleCheck = (value) => {
    setErrorModalDouble(true);
  };

  // COMPLETE SAVING GOAL API
  const HandleCompleteSavingGoal = async () => {
    const deviceId = await retrieveData("updatedDeviceId");
    const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
    const savingsAccount = cards?.find(
      (account) => account.AccountTypeBit63 == SAVING_CARD_CODE
    );
    const url = COMPLETE_SAVING_GOAL(savingsAccount.CardKey, manageSavingDataObj?.goalKey);
    const response = await PostRequest(url, {}, headers);
    const responseJson = JSON.parse(response);
    if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {

    } else {
      var arrMessages = responseJson.Messages;
      var message = arrMessages[0];
      var displayText = message.DisplayText;
    }
  }

  const handleRemoveClickNew = () => {
    if (manageSavingDataObj?.status === "ACT") {
      HandleCompleteSavingGoal()
    }

    dispatch({
      type: "SAVING_GOALS",
      payload: { key: "GoalKey", value: manageSavingDataObj?.goalKey },
    });

    openRemoveDoubleCheck(true);
  };

  const closeSuccessfullRemoveConfirm = () => {
    setErrorModalConfirm(false);
  };

  const handleDone = (transferBtn) => {
    if (transferBtn === "success") {
      setDoneModalOpen(true);
      setErrorModalConfirm(false);
    } else {
      setErrorModalConfirm(false);
      setTransferErrorMsg(true)
      setErrorMsg(transferBtn)
    }
  };

  const closeRemoveDoubleConfirm1 = () => {
    setErrorModalConfirm(false);
  };

  const closeSuccessfullRemoveDone = () => {
    navigate('/Toolkit/SavingGoals/ManageSavingGoal')
    setDoneModalOpen(false);
    setErrorModalConfirm(false);
  };

  const closeRemoveDoubleConfirm = () => {
    dispatch({ type: "RESET_ALLOCATE_FUND" })
    dispatch({ type: "RESET_SAVING_GOALS" })
    navigate("/Toolkit/ToolkitMenu");
  };



  const handleClimbFeatures = async () => {
    if (cards == null || cards == undefined) {
      return;
    }
    setIsLoading(true);
    const deviceId = await retrieveData("updatedDeviceId");
    const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
    const url = GET_CLIMB_FEATURES.replace("{CARD_KEY}", isPrimrayKey);
    const response = await GetRequest(url, headers);
    const responseJson = JSON.parse(response);
    if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
      //  debugger;
      const spendingAlertResponse = responseJson.Response.find(
        (obj) => obj.code === SPENDING_ALERT
      );
      if (spendingAlertResponse) {
        const isOptInValue = spendingAlertResponse.optedIn;
        setSpendingAlertCode(spendingAlertResponse.code);
        setIsOptIn(isOptInValue);
        setShowSubItems(isOptInValue);
      } else {
        // Handle the case where 'SpendingAlert' is not found in the response
      }
      const enabledClimbings = responseJson.Response.filter(
        (response) => response.enabled === true
      );
      setisClimbings(enabledClimbings);
      setIsLoading(false);
    } else {
      return [];
    }
  };

  //API Call-------------------
  const getAllSpendAlerts = async () => {
    if (isPrimrayKey == null || isPrimrayKey == undefined) {
      return;
    }
    try {
      //  debugger;
      setIsLoading(true);
      const deviceId = await retrieveData("updatedDeviceId");
      const cardKey = isPrimrayKey;
      const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
      const url = GET_ALL_SPEND_ALERTS(cardKey);
      const response = await GetRequest(url, headers);
      const responseJson = await JSON.parse(response);
      if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
        debugger;
        setspendAlertsArray(responseJson.Response);
        console.log(responseJson.Response);
        setSpendingCount(responseJson.Response.length);
        const SPENDSONSCOUNTPAYLOAD = {
          spendAlertCount:
            responseJson.Response.length > 0 ? responseJson.Response.length : 0,
        };
        dispatch({
          type: "SPENDS_ALERT_COUNT",
          payload: SPENDSONSCOUNTPAYLOAD,
        });
        setIsLoading(false);
      } else if (responseJson.Messages) {
        const displayErrorText = responseJson.Messages[0].DisplayText;
        setIsLoading(false);
      }
    } catch (error) { }
  };

  useEffect(() => {
    handleClimbFeatures();
    getAllSpendAlerts();
  }, [showSubItems, isOptIn, SpendingCount]);

  const [isOptInModalOpen, setIsOptInModalOpen] = useState(false);

  const closeOptInModal = () => {
    setIsOptIn((prev) => !prev);
    setIsOptInModalOpen(false);
  };

  ///////////////////////////////////HANDLE PAUSE AND RESUME MODAL POPUS  4

  const ManageSettingsbuttonLabels = [
    { label: "SpendSense Alerts", link: "/Toolkit/ManageSpendAlerts" },
    {
      label: "Covered by Kudzu",
      link: kudzuPlusTrue
        ? isCoveredByKudzuOptedIn || isCoveredByKudzuPlusOptedIn
          ? "/Toolkit/ManageCoveredByKudzu"
          : "/Toolkit/CoveredByKudzu"
        : isCoveredByKudzuOptedIn
          ? "/Toolkit/ManageCoveredByKudzu"
          : "/Toolkit/CoveredByKudzu",
    },
    { label: "Savings Habits", link: "/Toolkit/ManageSavingsHabit" },
    ...(issavingsGoalEligible ? [{ label: 'Savings Goals', link: isSavingsGoalsOptedIn ? '/Toolkit/SavingGoals/ManageSavingGoal' : '/Toolkit/ToolkitSettings' }] : []),
  ];

  const data = useSelector((state) => state.manageSavingData);
  const manageSavingDataObj = useSelector(
    (state) => state.manageSavingGoalDetailsObj
  );
  


  const ManageSavingTotalCount = useSelector(
    (state) => state.manageSavingTotalCount
  );

  const navigateClicked = (item) => {
    if (item.link == "/Toolkit/ManageSavingsHabit") {
      if (!savingsCardExist && item.label == "Savings Habits") {
        closeOptInModal();
        setIsCoveredByKudzuIneligibleSetupSavings(true);
      } else if (
        savingsCardExist &&
        savingsWithBalanceOver50 == undefined &&
        item.label != "Savings Habits"
      ) {
        closeOptInModal();
        setIsCoveredByKudzuIneligible(true);
      } else {
        navigate(item.link);
      }
    } else {
      navigate(item.link);
    }
  };


const totalAmount = data?.length
  ? data.reduce((sum, item) => sum + item.amount, 0)
  : 0;

const formattedAmount = manageSavingDataObj?.amount.toFixed(2);
const [beforeDecimal, afterDecimal] = formattedAmount.split(".");


  const targetAmountFormated = manageSavingDataObj?.targetAmount?.toFixed(2);
  const [targetAmountBeforeDecimal, targetAmountAfterDecimal] =
    targetAmountFormated?.split(".");

  const AmountFormated = manageSavingDataObj?.amount.toFixed(2);
  const [amountBeforeDecimal, amountAfterDecimal] = AmountFormated?.split(".");

  const InstallmentFormated = manageSavingDataObj?.installmentAmount.toFixed(2);
  const [installmentBeforeDecimal, installmentAfterDecimal] =
    InstallmentFormated?.split(".");

  const handleAllocateFund = () => {
    dispatch({
      type: "SAVING_GOALS",
      payload: { key: "Name", value: manageSavingDataObj?.goalName },
    });
    dispatch({
      type: "SAVING_GOALS",
      payload: { key: "Amount", value: manageSavingDataObj?.targetAmount },
    });
    dispatch({
      type: "SAVING_GOALS",
      payload: { key: "date", value: manageSavingDataObj?.targetDate === "9999-12-31T00:00:00" ? "" : manageSavingDataObj?.targetDate },
    });
    dispatch({
      type: "SAVING_GOAL_RESPONSE_DATA",
      payload: { savingGoalResponseData: manageSavingDataObj || "" },
    });
    dispatch({ type: "RESET_ALLOCATE_FUND" });
    dispatch({
      type: "SELECTED_FREQUENCY_VALUE",
      payload: { selectedFrequencyValue: "" },
    });

    dispatch({
      type: "ACCOUNT_BALANCE",
      payload: { accountBalance: null },
    });
    dispatch({
      type: "IS_INTERNAL_ACCOUNT",
      payload: { isInternalAccount: false }
    })

    dispatch({
      type: "SAVING_GOAL_ACCOUNT_TYPE_OBJ",
      payload: { savingGoalAccountTypeObj: {} }
    });

    navigate("/Climb/AllocateFund");
  };


  const handleAllocateFundEdit = (clickedFrom) => {
    const selectedAccount = accountObj.find(
      (item) => item?.AccountId == manageSavingDataObj?.fromAccount
    );
    const selectedFrequency = frequecyDataGetting.find(
      (item) => item?.Code == manageSavingDataObj?.frequency
    );
    if (selectedAccount?.ACHAccountInternalId == 0) {

      const internalAccount = cards?.find((card) => card.CardKey === selectedAccount?.AccountId);
      dispatch({
        type: "ACCOUNT_BALANCE",
        payload: { accountBalance: internalAccount?.Balance.toFixed(2) },
      });
      dispatch({
        type: "IS_INTERNAL_ACCOUNT",
        payload: { isInternalAccount: true }
      })
    } else {
      dispatch({
        type: "ACCOUNT_BALANCE",
        payload: { accountBalance: 0 },
      });
      dispatch({
        type: "IS_INTERNAL_ACCOUNT",
        payload: { isInternalAccount: false }
      })

    }
    dispatch({
      type: "SAVING_GOALS",
      payload: { key: "Name", value: manageSavingDataObj?.goalName },
    });

    dispatch({
      type: "SAVING_GOALS",
      payload: { key: "GoalKey", value: manageSavingDataObj?.goalKey },
    });


    dispatch({
      type: "SAVING_GOALS",
      payload: { key: "Amount", value: manageSavingDataObj?.targetAmount.toFixed(2) },
    });

    dispatch({
      type: "SAVING_GOALS",
      payload: { key: "SavingAmount", value: manageSavingDataObj?.amount },
    });

    dispatch({
      type: "ALLOCATE_FUND",
      payload: {
        key: "Installments",
        value: manageSavingDataObj?.installmentAmount.toFixed(2)
      },
    });

    dispatch({
      type: "ALLOCATE_FUND",
      payload: { key: "email", value: manageSavingDataObj?.isEmail },
    });
    dispatch({
      type: "ALLOCATE_FUND",
      payload: { key: "sms", value: manageSavingDataObj?.isSms },
    });
    dispatch({
      type: "ALLOCATE_FUND",
      payload: { key: "TargetDate", value: manageSavingDataObj?.targetDate === "9999-12-31T00:00:00" ? "" : manageSavingDataObj?.targetDate },
    });
    dispatch({
      type: "ALLOCATE_FUND",
      payload: { key: "StartDate", value: manageSavingDataObj?.startDate === "9999-12-31T00:00:00" ? "" : manageSavingDataObj?.startDate },
    });
    dispatch({
      type: "ALLOCATE_FUND",
      payload: { key: "EndDate", value: manageSavingDataObj?.endDate === "9999-12-31T00:00:00" ? "" : manageSavingDataObj?.endDate },
    });

    dispatch({
      type: "SAVING_GOAL_RESPONSE_DATA",
      payload: { savingGoalResponseData: manageSavingDataObj || {} },
    });
    dispatch({
      type: "SELECTED_FREQUENCY_VALUE",
      payload: { selectedFrequencyValue: selectedFrequency || {} },
    });
    dispatch({
      type: "SAVING_GOAL_ACCOUNT_TYPE_OBJ",
      payload: { savingGoalAccountTypeObj: selectedAccount || {} },
    });
    navigate("/Toolkit/SavingGoals/ManageSavingGoal/Edit");

    logFirebaseEvents(
      "Saving_Goal",
      "Allocate_Fund_Clicked",
      "Allocate_Fund_Clicked",
      "",
      ""
    );
  };



  const isTargetDateYesterday = (() => {
    if (!manageSavingDataObj?.targetDate) return false;
    const target = new Date(manageSavingDataObj.targetDate);
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return target.toDateString() === yesterday.toDateString();
  })();


  const HeaderContentBar = () => {
    return (
      <div className="flex justify-center lg:mt-8 md:mt-6 sm:mx-0 md:ml-[-53px] text-[#fff]">
        <div className=" w-full lg:w-[75%] sm:w-[81%] px-4 sm:px-0 p-2">
          <p className="font-normal text-[18px] md:text-[18px] sm:text-[14px] mb-2 font-hanken-grotesk">
            {manageSavingDataObj?.goalName || ""}
          </p>
          <ProgressBar
  filledbgColor={"#30BC89"}
  unfilledBg={"#262B3A"}
  progressBarWidth={"100%"}
  progressBarHeight={"6px"}
  progress={
    manageSavingDataObj?.status === "CMP" && manageSavingDataObj?.amount === 0
      ? 100
      : manageSavingDataObj?.percentage > 100
        ? 100
        : manageSavingDataObj?.percentage
  }
          />
          <div className="flex justify-between mt-2">
            <p className="font-normal text-[14px] md:text-[14px] sm:text-[14px] font-hanken-grotesk  ">
              {`${(manageSavingDataObj?.status === "CMP" && manageSavingDataObj?.amount === 0)
  ? 100
  : manageSavingDataObj?.percentage || 0}%`}
            </p>
            <p className="font-normal text-[14px] md:text-[14px] sm:text-[14px] font-hanken-grotesk">
              <div className="flex font-hanken-grotesk">
                <div className="">${targetAmountBeforeDecimal}</div>
                <div className=" ">.</div>
                <div className=" font-hanken-grotesk">
                  {targetAmountAfterDecimal}
                </div>
              </div>
            </p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <HomeLayout>
        <ClimbManageSettingsSidebar
          indexBtn={4}
          ManageSettingsbuttonLabels={ManageSettingsbuttonLabels}
          headingMessage={false}
          count={ManageSavingTotalCount || 0}
          isShow={true}
          navigateClicked={navigateClicked}
        />
        <div
          className="flex flex-col md:w-[860px] sm:w-[464px]
            w-[100%] animate__animated animate__fadeInRight "
        >
          <DynamicCard
            header={false}
            CardRadius={true}
            cardWidth={width.homeCard}
            HeaderRadius={true}
            footer={true}
            isWhite={appThemeData.isWhiteBgForCard}
            isDarkForKudzu={appThemeData.isDarkBgForCard}
            backgroundColor={"--cardHeading-bg"}
            HeaderContent={
              <>
                {HeaderContentBar()}
              </>
            }
          >
            <>
              <div
                className={`${kudzuPlusTrue ? "" : "border-[#94C3E8] border-b-[3px]"
                  } sm:mx-0 mx-4`}
              ></div>

              <div className="flex justify-center lg:mt-8 md:mt-6 sm:mx-0 md:ml-[-53px]">
                <div className="w-full lg:w-[70%] sm:w-[81%] px-4 sm:px-0">
                  {/* Card Header */}
                  <div className="w-full sm:w-[550px]">
                    <div className="flex justify-between mt-[2rem]">
                      <div className="flex md:font-[400] sm:font-[400] font-[400]  md:leading-[56px] sm:leading-[28.38px] leading-[37.49px]  text-[#94C3E8] font-hanken-grotesk">
                        <div className="lg:text-[44px] md:text-[38px] sm:text-[23px] text-[38px]">
                          ${beforeDecimal}
                        </div>
                        <div className="lg:text-[43px] md:text-[30px] sm:text-[20px] text-[35px] lg:mt-[-12px] md:mt-[-7px] sm:mt-[-5px] mt-[-11px] md:font-[500] font-[300]">
                          .
                        </div>
                        <div
                          className="lg:text-[30px] md:text-[20px] sm:text-[15px] text-[20px] lg:mt-[-6px] md:mt-[-4px] sm:mt-[-3px] mt-[-5px] md:font-[500] font-[300]
                        font-hanken-grotesk"
                        >
                          {afterDecimal}
                        </div>
                      </div>
                      {manageSavingDataObj?.status === "CMP" ?  (
                       <div className=" ">
                            <div className="w-full sm:w-[200px] md:w-[174px] lg:w-[178px] h-[30px] sm:h-[30px] mt-4 lg:h-[30px] flex items-center justify-center rounded-full bg-[#324261] text-[#8CB5FF] text-[12px] md:text-[14px] lg:text-[16px] font-hanken-grotesk font-semibold">
                              {t("Completed_goal")}
                            </div>
                      </div>
                      ):(
                         <div className=" ">
                        {manageSavingDataObj?.showMarkAsCompleted ?
                          (
                            <div className="w-full sm:w-[200px] md:w-[174px] lg:w-[178px] h-[30px] sm:h-[30px] mt-4 lg:h-[30px] flex items-center justify-center rounded-full bg-[#324261] text-[#8CB5FF] text-[12px] md:text-[14px] lg:text-[16px] font-hanken-grotesk font-semibold">
                              {t("goal_reached")}
                            </div>

                          ) : (
                            <button
                              disabled={manageSavingDataObj?.isLocked}
                              onClick={() => handleAllocateFund("add")}
                              className="w-full  sm:w-[200px] md:w-[174px] lg:w-[178px] h-[40px] sm:h-[50px] lg:h-[50px] text-[12px] md:text-[14px] lg:text-[16px] font-hanken-grotesk rounded-full px-4 sm:px-6 md:px-12 text-white borderGradient py-2 sm:py-[6.11px] cursor-pointer disabled:opacity-50"
                            >
                              {t("add_fund")}
                            </button>
                          )}
                      </div>
                      )}
                   
                    </div>
                  </div>

                  {/* Card Details Section */}
                  <div className="pt-8 sm:pt-24 pb-4 sm:pb-7">
                    <div className="flex flex-col sm:flex-row sm:gap-44">
                      <div className="flex flex-col gap-4 sm:gap-7 items-start">
                        <p className="uppercase tracking-[2px] text-[#779CE5] text-[12px] font-bold">
                          {t("amount_savings")}
                        </p>
                        <p className="font-hanken-grotesk text-[16px] font-medium text-[#FFFFFF]">
                          <div className="flex font-hanken-grotesk">
                            <div className="">${amountBeforeDecimal}</div>
                            <div className=" ">.</div>
                            <div className=" font-hanken-grotesk">
                              {amountAfterDecimal}
                            </div>
                          </div>
                        </p>
                           {manageSavingDataObj?.status === 'CMP' ? (
                        <>   <p className="uppercase tracking-[2px] text-[#779CE5] text-[12px] font-bold">
                            {t("ALLOCATED TO")}
                          </p>
                          <p className="font-hanken-grotesk text-[16px] font-medium text-[#FFFFFF]">
                           {manageSavingDataObj?.AllocatedTo || "----"}
                          </p></>
                       ):(
                        <>
                          <p className="uppercase tracking-[2px] text-[#779CE5] text-[12px] font-bold">
                            {t("freq")}
                          </p>
                          <p className="font-hanken-grotesk text-[16px] font-medium text-[#FFFFFF]">
                            {manageSavingDataObj?.frequency
                              ? manageSavingDataObj?.frequency === "OT"
                                ? "One Time"
                                : manageSavingDataObj?.frequency === "DY"
                                  ? "Daily"
                                  : manageSavingDataObj?.frequency === "WY"
                                    ? "Weekly"
                                    : manageSavingDataObj?.frequency === "MY"
                                      ? "Monthly"
                                      : "" || ""
                              : "----"}
                          </p>
                          {!manageSavingDataObj?.fromAccountType && (
                            <>
                              <p className="uppercase tracking-[2px] text-[#779CE5] text-[12px] font-bold">
                                {t("installments")}
                              </p>
                              <p className="font-hanken-grotesk text-[16px] font-medium text-[#FFFFFF]">
                                <div className="flex font-hanken-grotesk">
                                  <div className="">
                                    ${installmentBeforeDecimal}
                                  </div>
                                  <div className=" ">.</div>
                                  <div className=" font-hanken-grotesk">
                                    {installmentAfterDecimal}
                                  </div>
                                </div>
                              </p>
                            </>
                          )}
                          {manageSavingDataObj?.fromAccountType ? (
                            <>
                              <p className="uppercase tracking-[2px] text-[#779CE5] text-[12px] font-bold">
                                {t("allocate_funds")}
                              </p>
                              <p className="font-hanken-grotesk text-[16px] font-medium text-[#FFFFFF]">
                                {manageSavingDataObj?.fromAccountType}
                              </p>
                            </>
                          ) : (
                            ""
                          )}
                        </>
                          )}
                      </div>
                      <div className="flex flex-col gap-4 sm:gap-7 items-start">
                        {manageSavingDataObj?.status === 'CMP' ? 
                        (
                          <>
                          <p className="uppercase tracking-[2px] text-[#779CE5] text-[12px] font-bold">
                          {t("Completion_Date")}
                        </p>
                         <p className="font-hanken-grotesk text-[16px] font-medium text-[#FFFFFF]">
                           {manageSavingDataObj?.completionDate &&
                            manageSavingDataObj?.completionDate !==
                            "9999-12-31T00:00:00"
                            ? moment(manageSavingDataObj?.completionDate).format(
                              "MMMM DD, YYYY"
                            )
                            : "----"}
                        </p>
                        </>
                        ):(
                          <>
                          <p className="uppercase tracking-[2px] text-[#779CE5] text-[12px] font-bold">
                          {t("target_amt")}
                        </p>
                        <p className="font-hanken-grotesk text-[16px] font-medium text-[#FFFFFF]">
                          <div className="flex font-hanken-grotesk">
                            <div className="">${targetAmountBeforeDecimal}</div>
                            <div className=" ">.</div>
                            <div className=" font-hanken-grotesk">
                              {targetAmountAfterDecimal}
                            </div>
                          </div>
                        </p>
                        </>
                        )}
                        
                      {manageSavingDataObj?.status === 'ACP' && (
                      <>
                        <p className="uppercase tracking-[2px] text-[#779CE5] text-[12px] font-bold">
                          {t("target_date")}
                        </p>
                        <p className="font-hanken-grotesk text-[16px] font-medium text-[#FFFFFF]">
                          {manageSavingDataObj?.targetDate &&
                            manageSavingDataObj?.targetDate !==
                            "9999-12-31T00:00:00"
                            ? moment(manageSavingDataObj?.targetDate).format(
                              "MMMM DD, YYYY"
                            )
                            : "----"}
                        </p>
                         </>
                     )}

                        {manageSavingDataObj?.fromAccountType && (
                          <>
                            <p className="uppercase tracking-[2px] text-[#779CE5] text-[12px] font-bold">
                              {t("installments")}
                            </p>
                            <p className="font-hanken-grotesk text-[16px] font-medium text-[#FFFFFF]">
                              <div className="flex font-hanken-grotesk">
                                <div className="">
                                  ${installmentBeforeDecimal}
                                </div>
                                <div className=" ">.</div>
                                <div className=" font-hanken-grotesk">
                                  {installmentAfterDecimal}
                                </div>
                              </div>
                            </p>
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Edit Goal Button */}

                  <div className="w-full sm:w-[534px] my-16 pb-4 sm:pb-10 pt-4 sm:pt-7">
                    {manageSavingDataObj?.status === "ACT" && <>
                      {manageSavingDataObj?.showMarkAsCompleted ? (
                        <>
                          <button type="button"
                            className="py-2 sm:py-4 mb-4 px-4 md:px-6 lg:px-[93px] bg-[#26C281] text-white font-hanken-grotesk font-semibold w-full text-[12px] sm:text-[14px] lg:text-[16px]"
                            onClick={handleRemoveClickNew}
                          >
                            {t("Mark_Goal_As_Complete")}
                          </button>
                          <button type="button"
                            className="border-[#4B70B9]  border-[3px] py-2 sm:py-4 px-4 md:px-6 lg:px-[93px] bg-[#2C3449] text-[#FFFFFF] font-hanken-grotesk font-semibold w-full text-[12px] sm:text-[14px] lg:text-[16px]"
                            onClick={handleAllocateFundEdit}
                          >
                            {t("Edit_Goal")}
                          </button>
                        </>
                      ) : (manageSavingDataObj?.fromAccountType || parseInt(manageSavingDataObj?.percentage) >= 0) ? (
                        <button type="button"
                          className="border-[#4B70B9] border-[3px] py-2 sm:py-4 px-4 md:px-6 lg:px-[93px] bg-[#2C3449] text-[#FFFFFF] font-hanken-grotesk font-semibold w-full text-[12px] sm:text-[14px] lg:text-[16px]"
                          onClick={handleAllocateFundEdit}
                        >
                          {t("Edit_Goal")}
                        </button>
                      ) : null}</>
                    }

                    {manageSavingDataObj?.status === "CMP" && (
                      <>
                        {!(manageSavingDataObj?.FundMoved > 0 || manageSavingDataObj?.amount === 0) && (
                          <button type="button"
                            className="py-2 sm:py-4 mb-4 px-4 md:px-6 lg:px-[93px] bg-[#2965FB] text-white font-hanken-grotesk font-semibold w-full text-[12px] sm:text-[14px] lg:text-[16px]"
                            onClick={handleRemoveClickNew}
                          >
                            {t("New_Allocate_Fund")}
                          </button>
                        )}
                        <button type="button"
                          className="border-[#4B70B9] border-[3px] py-2 sm:py-4 px-4 md:px-6 lg:px-[93px] bg-[#2C3449] text-[#FFFFFF] font-hanken-grotesk font-semibold w-full text-[12px] sm:text-[14px] lg:text-[16px]"
                          onClick={handleSavinggoalRemove}
                        >
                          {t("Remove_Goal")}
                        </button>
                      </>
                    )}



                  </div>
                </div>
              </div>
            </>
          </DynamicCard>
        </div>
      </HomeLayout>
      {isLoading && <Loader />}

      <Modal
        Fullheight={true}
        isOpen={errorModalDouble}
        onClose={closeRemoveDoubleCCheck}
        alignItems={"items-center"}
        isClimbg={true}

        subtitle={

          <p>
            <span className={`${HeadingStyles} visible sm:hidden`}>
              {t("removeSpednAlert")}
            </span>
            <span className={`${SubHeadingStyles} !text-[#94C3E8]`}>
              {t("Wow!")}
            </span>
            <span className={`${SubHeadingStyles}`}>
              {t("You've_reached")}
            </span>
          </p>
        }
        content={
          <div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6">
            < CompleteSavingGoalConfirmRemoval
              content1={hasMultipleSVGGoals || parseInt(manageSavingDataObj?.percentage) > 100 ? t("Has_Svg_Content") : t("No_Svg_Content")}
              btn1={hasMultipleSVGGoals || parseInt(manageSavingDataObj?.percentage) > 100 ? t("Allocate Funds") : t("Transfer Funds")}
              btn1Function={removeGoalClick}
              btn2={t("Back to Toolkit")}
              btn2Function={closeRemoveDoubleCCheck}
            />
          </div>
        }
      />


      <Modal
        isOpen={errorModalConfirm}
        onClose={closeSuccessfullRemoveConfirm}
        alignItems={"items-center"}
        isClimbg={true}
        subtitle={
          <p>
            <span className={`${HeadingStyles} visible sm:hidden`}>
              {t("done_exclamation")}
            </span>
            <span className={`${SubHeadingStyles} !text-[#94C3E8]`}>
              {t("okay_exlr")}
            </span>
            <span className={`${SubHeadingStyles} !text-[#FFFFFF]`}>
              {t("remove_goal_header_success")}
            </span>
          </p>
        }
        content={
          <div class="aspect-454/253 md:mt-10 sm:mt-3 mt-6">
            <TransaferFundsCompleteGoalModal
              content1={t("Choose_From_Below")}
              btn1={t("Move Funds")}
              transferBtn={handleDone}
              btn2={t("Cancel")}
              btn2Function={closeRemoveDoubleConfirm1}
            />
          </div>
        }
      />

      <Modal
        isOpen={doneModal}
        onClose={closeSuccessfullRemoveDone}
        alignItems={"items-center"}
        isClimbg={true}
        subtitle={
          <p>
            <span className={`${HeadingStyles} visible sm:hidden`}>
              {t("done_exclamation")}
            </span>
            <span className={`${SubHeadingStyles} !text-[#94C3E8]`}>
              {t("Done!")}
            </span>
            <span className={`${SubHeadingStyles} !text-[#FFFFFF]`}>
              {t("we_moved_the_funds_from")} {AccountName}
            </span>
          </p>
        }
        content={
          <div class="aspect-454/253 md:mt-10 sm:mt-3 mt-6">
            <CompletedDoneModalGoalRemove
              content1={
                <div className="flex flex-col gap-5">
                  <p className="text-[#FFFFFF] font-medium font-hanken-grotesk text-[20px]">
                    {addLineBreaks(t("Your_on_roll"))}
                  </p>
                </div>

              }
              btn1={t("Create_Goal")}
              btn1Function={() => navigate("/Toolkit/SavingGoals")}
              btn2={t("back_climb")}
              btn2Function={closeRemoveDoubleConfirm}
            />
          </div>
        }
      />

      <Modal
        Fullheight={true}
        isOpen={RemoveGoalerrorModalDouble}
        onClose={closeGoalRemoveDoubleCCheck}
        alignItems={"items-center"}
        isClimbg={true}
        // title={<p className={`${HeadingStyles} hidden sm:flex`}>{t('removeSpednAlert')}</p>}
        subtitle={

          <p>
            <span className={`${HeadingStyles} visible sm:hidden`}>
              {t("removeSpednAlert")}
            </span>
            <span className={`${SubHeadingStyles} !text-[#94C3E8]`}>
              {t("Hold_On")}
            </span>
            <span className={`${SubHeadingStyles}`}>
              {t("Are_U_Sure_Remove")}
            </span>
          </p>
        }
        content={
          <div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6">
            <SuccesRemoveGoal
              content1={t("Content_For_Remove_Goal")}
              btn1={t("Remove_Goal")}
              btn1Function={removeSavigGoalClick}
              btn2={t("cancel")}
              btn2Function={closeGoalRemoveDoubleCCheck}
              icon={true}
            />
          </div>
        }
      />

      <Modal
        isOpen={RemoveGoalErrorModalConfirm} 
        onClose={closeConfirmremoveGoaal}
        alignItems={"items-center"}
        isClimbg={true}
        // title={<p className={`${HeadingStyles} hidden sm:flex`}>{t('done_exclamation')}</p>}
        subtitle={
          <p>
            <span className={`${HeadingStyles} visible sm:hidden`}>
              {t("done_exclamation")}
            </span>
            <span className={`${SubHeadingStyles} !text-[#94C3E8]`}>
              {t("ok_exclr")}
            </span>
            <span className={`${SubHeadingStyles} !text-[#FFFFFF]`}>
              {t("remove_goal_header_success")}
            </span>
          </p>
        }
        content={
          <div class="aspect-454/253 md:mt-10 sm:mt-3 mt-6">
            <SuccessRemoveGoalConfirm
              content1={t("remove_goal_content_success")}
              btn1={t("transfer_remove_goal")}
              transferBtn={handleDoneRemove}
              btn2={t("Cancel")}
              btn2Function={closeConfirmremoveGoaal}
            />
          </div>
        }
      />

      <Modal
        isOpen={removegoaldoneModal}
        onClose={closeRomvegoalSuccessfullDone}
        alignItems={"items-center"}
        isClimbg={true}
        // title={<p className={`${HeadingStyles} hidden sm:flex`}>{t('done_exclamation')}</p>}
        subtitle={
          <p>
            <span className={`${HeadingStyles} visible sm:hidden`}>
              {t("done_exclamation")}
            </span>
            <span className={`${SubHeadingStyles} !text-[#94C3E8]`}>
              {t("done_exclr")}
            </span>
            <span className={`${SubHeadingStyles} !text-[#FFFFFF]`}>
              {t("saving_goal_del")}
            </span>
          </p>
        }
        content={
          <div class="aspect-454/253 md:mt-10 sm:mt-3 mt-6">
            <DoneModalGoalRemove
              content1={
                manageSavingDataObj?.FundMoved === 0 ? (
                  <div className="flex flex-col gap-5">
                    {
                      AccountType === 'Savings' ? <p>{t("done_cont")} </p> : AccountType === 'Spending' ? <p>{t('done_cont_spending')}</p> : <p>{t("The_money_for_savingGoal").replace("{ACTIVE_ALERTS}", (AccountName !== undefined) ? AccountName : '')}</p>
                    }
                    <p className="text-[#FFFFFF] font-medium font-hanken-grotesk text-[20px]">
                      {addLineBreaks(t("cont1"))}
                    </p>
                    <p className="text-[#FFFFFF] font-medium font-hanken-grotesk text-[20px]">
                      {addLineBreaks(t("cont2"))}
                    </p>
                  </div>
                ) : null
              }
              btn1={t("back_climb")}
              btn1Function={() => navigate("/Toolkit/ToolkitMenu")}
              btn2={t("back_saving_goal")}
              btn2Function={navigateremovegoalDoubleConfirm}
            />
          </div>


        }
      />

      <Modal
        isOpen={removeErrorMsg}
        onClose={(e) => {
          setRemoveErrorMsg(false);
          navigate("/Toolkit/SavingGoals/ManageSavingGoal/ManageSavingGoalDetails");
        }}
        alignItems={"items-center"}
        isClimbg={true}

        subtitle={
          <p>
            <span className={SubHeadingStyles}><span className={`${HeadingStyles}`}>{t('oops_exclamation')} </span>{errorMsg}</span>
          </p>
        }
        content={
          <div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6">
            <TransferErrorModal ModalClose={handleTranferCloseModal} />
          </div>
        }
      />
    </>
  );
};

export default withOidcSecure(ManageSavingGoalDetail);
